import React from 'react';

/** Save icon (Sam, Oct 15): outline bookmark = not saved, filled bookmark with a check = saved. */
const BookmarkIcon = ({ on, className }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
    <path
      d="M6.5 3.5h11a1 1 0 0 1 1 1v16l-6.5-4.2-6.5 4.2v-16a1 1 0 0 1 1-1z"
      fill={on ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinejoin="round"
    />
    {on ? (
      <path d="M8.7 9.6l2.3 2.3 4.3-4.4" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    ) : null}
  </svg>
);

export default BookmarkIcon;
